namespace Gordic.Vyp.Lists
{
    @Decorators.gcontent
    export class VypraveneZasilkyListPage extends GContentBase<VypListBasePage>
    {
        onContentReady()
        {
            Wfl.ListAC.WflZasilkyListBaseAC.InitList(this);
            this.specialActions.push(Wfl.ListAC.WflZasilkyListBaseAC.CreateActionServisniSeznamDZ(this, true));
            this.printActionsSubmenu.push(VypListBasePage.CreateActionTiskKnihyVypravenePosty(this));
            this.printActionsSubmenu.push(VypListBasePage.CreateActionTiskVykazu(this));
            this.printActionsSubmenu.push(VypListBasePage.CreateActionTiskNakladu(this));
            Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            Wfl.ListAC.WflZasilkyListBaseAC.CreateList(this);
        }

        ReloadData()
        {
            Wfl.ListAC.WflZasilkyListBaseAC.LoadDataZasilek(this, this.model);
        }
    }
}
